module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"CovidVaxMap","short_name":"CovidVaxMap","start_url":"/","background_color":"#ffffff","theme_color":"#000000","display":"standalone","icon":"src/images/icon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"cbdbfd35e921e0ce60de01784e982577"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
